<template>
  <div id="AddTimeline">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="timelineText">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div id="pageEditor">
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <v-textarea
                    label="Add Timeline text here..."
                    :rules="rules"
                    class="required  pr-4 pl-4"
                    no-resize
                    rows="10"
                    v-model="timelineText"
                    @click="selectedData=true"
                    hint="Timeline text required"
              ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store */
import { create, getCollection } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';

export default {
  name: 'Timeline',
  data: () => ({
    selectedData: false,
    timelineText: '',
    rules: [
      v => !!v || 'File description is required'
    ]
  }),
  computed: {
    ...mapGetters([]),
    Timeline: {
      get () {
        return store.state.Timeline;
      },
      set (value) {
        store.commit('setTimeline', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.getTimeLines();
  },
  methods: {
    async getTimeLines () {
      if (!this.Timeline.length) {
        let entity = `Timeline`;
        let sessionUser = session.getSession();
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Timeline = data;
          }
        }
      }
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/timelines' });
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      window.getApp.$emit('pageSubHeader', '');
      this.selectedData = false;
      this.$router.push({ path: '/timelines' });
    },
    async save () {
      if (this.$refs.timelineText.validate()) {
        this.selectedData = false;
        let TimelineObj = {
          text: this.timelineText,
          title: 'Custom Timeline',
        };
        if (session.getSession().adminUser) {
          TimelineObj.account = session.getSession().user.human.account.id;
        }
        let { error, data } = await create('Timeline', TimelineObj);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.Timeline.unshift(data);
          swal.fire({
            type: 'success',
            title: 'Timeline added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/timelines' });
            }
          });
        }
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Timelines/add.vue